import { render } from "./Minus.vue.js?vue&type=template&id=2c10e6c6!=!../vue-loader/dist/index.js??ruleSet[0]!./Minus.vue?vue&type=template&id=2c10e6c6"
import script from "./Minus.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Minus.vue?vue&type=script&lang=js"
export * from "./Minus.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Minus.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__